module.exports = __webpack_public_path__ + "img/report.6517b315.svg";